export const styles = {
  accordion: {
    height: '100%',
    maxHeight: '100%',
    position: 'relative',
    display: 'flex',
    flexFlow: 'column',
  },
};
